import { render, staticRenderFns } from "./wdwzBanKuai.vue?vue&type=template&id=4b5ce597&scoped=true"
import script from "./wdwzBanKuai.vue?vue&type=script&lang=js"
export * from "./wdwzBanKuai.vue?vue&type=script&lang=js"
import style0 from "./wdwzBanKuai.vue?vue&type=style&index=0&id=4b5ce597&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5ce597",
  null
  
)

export default component.exports